import Link from 'next/link';
import { FC } from 'react';
import clsx from 'clsx';

import { getIndexUrl } from 'navigation/urls';

import LogoBlack from '../../../public/img/logo-black.svg';
import LogoWhite from '../../../public/img/logo-white.svg';

interface Props {
  className?: string;
  whiteText?: boolean;
}

const Logo: FC<Props> = ({ className, whiteText = false }) => (
  <Link href={getIndexUrl()} legacyBehavior>
    <a
      className={clsx(
        className,
        'flex w-[150px] h-[52px] tablet:w-[160px] tablet:h-[67px]'
      )}
      aria-label="Frontpage"
    >
      {whiteText ? <LogoWhite /> : <LogoBlack />}
    </a>
  </Link>
);

export default Logo;
